import { render, staticRenderFns } from "./AboutUSPartner.vue?vue&type=template&id=784d09ee"
import script from "./AboutUSPartner.vue?vue&type=script&lang=js"
export * from "./AboutUSPartner.vue?vue&type=script&lang=js"
import style0 from "./AboutUSPartner.vue?vue&type=style&index=0&id=784d09ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports